import { configWithUserToken } from "./config";

export interface IVirtualMachine {
  id: string;
  hostname: string;
  state: string;
  plan: string;
  operatingSystem: string;
  cpus: number;
  memoryMb: number;
  diskMb: number;
  primaryIpv4: string;
  createdAtUtc: string;
}

export interface IVirtualMachineMetrics {
  sampledAtUtc: string;
  cpuUsagePercent: number;
  ramUsedBytes: number;
  ramUsedPercent: number;
  diskUsedBytes: number;
  diskUsedPercent: number;
  incomingTrafficBytes: number;
  outgoingTrafficBytes: number;
  uptimeSeconds: number;
}

export interface IInfrastructureStatus {
  reachable: boolean;
  checkedAtUtc: string;
  fromCache: boolean;
  virtualMachines: IVirtualMachine[];
  metrics: Record<string, IVirtualMachineMetrics>;
}

export const getInfrastructureStatus = () =>
  configWithUserToken.get<IInfrastructureStatus>("Infrastructure/status");
